export const VITE_PRELOAD_RELOAD_GUARD = 'linkflare:vite-preload-reload-pending'

/**
 * Recover an old tab whose hashed lazy-route asset was removed by a deploy.
 * The session guard survives the reload so a persistent asset failure remains
 * observable instead of causing a reload loop.
 */
export function recoverFromVitePreloadError(
  event,
  {
    storage = window.sessionStorage,
    reload = () => window.location.reload()
  } = {}
) {
  try {
    if (storage.getItem(VITE_PRELOAD_RELOAD_GUARD)) return false
    storage.setItem(VITE_PRELOAD_RELOAD_GUARD, '1')
  } catch {
    // Without persistent session state, reloading could loop forever.
    return false
  }

  event.preventDefault()
  reload()
  return true
}

export function clearVitePreloadReloadGuard(storage = window.sessionStorage) {
  try {
    storage.removeItem(VITE_PRELOAD_RELOAD_GUARD)
  } catch {
    // Storage can be unavailable in restricted/private browsing contexts.
  }
}

export function installVitePreloadRecovery(
  target = window,
  dependencies
) {
  const handler = (event) => recoverFromVitePreloadError(event, dependencies)
  target.addEventListener('vite:preloadError', handler)
  return () => target.removeEventListener('vite:preloadError', handler)
}
